/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleListRequest {
    getFixupPrototypeFunction() { return ScheduleListRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleListRequest>): ScheduleListRequest {
        let obj = Object.assign(new ScheduleListRequest(), model);
        ScheduleListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleListRequest>): ScheduleListRequest {
        if (!model) return null;
        return ScheduleListRequest.newInstance(<ScheduleListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleListRequest) {
        if (!obj) return;

        models.ScheduleListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleListRequest): boolean {
        Object.setPrototypeOf(obj, ScheduleListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ScheduleFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ScheduleListSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ScheduleListSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ScheduleFilter;

}
